// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"bef268b8","35":"d93a49a8","460":"956617ef","684":"f4abfe2d","987":"68439078"}[chunkId] + ".js";
};